import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './campaign-submitted.component.less'],
  templateUrl: './campaign-submitted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunEachDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignSubmittedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CampaignSubmittedTemplateData>;
}

export type Campaign = {
  title: string;
  duration: string;
  time_to_setup: string;
  price: string;
};

export type CampaignSubmittedTemplateData = {
  header: string;
  subheader: string;
  body: string;
  footer: string;
  order_summary: string;
  total: string;
  total_price: string;
  campaigns: Campaign[];
};

export const CampaignSubmittedTemplateMocks: CampaignSubmittedTemplateData[] = [
  {
    header: 'Campaign successfully submitted',
    subheader:
      'Your campaign, [Campaign Name], has been successfully submitted and payment has been completed.',
    body: "We'll keep you updated on the status of each channel. You can also track these changes anytime through our app.",
    footer: 'Need help? support@recruitee.com',
    order_summary: 'Order summary:',
    total: 'Total: 1476 €',
    total_price: '1476 €',
    campaigns: [
      {
        title: 'Campaign 1',
        duration: '1 day',
        time_to_setup: '1 hour',
        price: '100$',
      },
      {
        title: 'Campaign 2',
        duration: '2 days',
        time_to_setup: '2 hours',
        price: '200$',
      },
    ],
  },
];
